import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { MiseadispoAuto } from '../models/miseadispo-auto.model';
import { Miseadispo } from '../models/miseadispo.model';

@Injectable({
  providedIn: 'root'
})
export class MiseadispoService {
  constructor(
    private api: ApiService
  ) {}

  // Récupère les mises à disposition validées (celles que les étudiants voient)
  getMiseadispos(): Observable<Miseadispo[]> {
    return this.api.get<Miseadispo[]>('/labase/miseadispos');
  }

  // Nouvelle méthode simplifiée qui récupère automatiquement pour le magasin de l'utilisateur connecté
  getMyMiseadisposAuto(): Observable<MiseadispoAuto[]> {
    return this.api.get<MiseadispoAuto[]>('/labase/miseadispos/auto/my-magasin');
  }

  // Méthode originale conservée pour compatibilité
  getMiseadisposAutoByMagasin(magasinId: number): Observable<MiseadispoAuto[]> {
    return this.api.get<MiseadispoAuto[]>(`/labase/miseadispos/auto/magasin/${magasinId}`);
  }

  validateMiseadispoAuto(id: string, quantite?: number): Observable<any> {
    return this.api.post<any>(`/labase/miseadispos/auto/${id}/validate`, { quantite });
  }

  validateAllMiseadisposAuto(): Observable<any> {
    return this.api.post<any>('/labase/miseadispos/auto/validate-all', {});
  }

  createFromArticles(products: Array<{plu: number, quantite: number}>, magasinId: number): Observable<any> {
    return this.api.post<any>('/labase/miseadispos/from-articles', { products, magasinId });
  }

  // Annule une mise à disposition (la rend "Pas Disponible")
  cancelMiseadispo(id: number | string): Observable<any> {
    return this.api.post<any>(`/labase/miseadispos/${id}/cancel`, {});
  }

  // Récupère les produits récemment mis à disposition
  getRecentMiseadispos(): Observable<Miseadispo[]> {
    return this.api.get<Miseadispo[]>('/labase/miseadispos/recent-donations');
  }

  // Supprime une mise à disposition
  deleteMiseadispo(id: number | string): Observable<any> {
    return this.api.delete<any>(`/labase/miseadispos/${id}`);
  }

  /**
   * Renvoie la notification de mise à disposition aux étudiants du magasin
   */
  resendNotification(): Observable<{ success: boolean; message: string; productCount?: number }> {
    return this.api.post<{ success: boolean; message: string; productCount?: number }>(
      '/labase/miseadispos/resend-notification', {}
    );
  }

  /**
   * Triggers N8N webhook to process product availability updates via backend
   * Returns immediately after webhook confirms receipt
   */
  triggerN8nWebhook(): Observable<{ success: boolean; n8nResponse?: any; error?: string }> {
    // Appelle l'endpoint backend qui gère l'appel à n8n avec https.Agent
    return this.api.get<{ success: boolean; n8nResponse?: any; error?: string }>(
      '/labase/miseadispos/trigger-n8n'
    );
  }
}
